import axios from './_nestAxios'

export const obtenerNuevoNumero = ({ tipoDocumento, serieDocumento, tipoOperacion }) =>
  axios.get('/series-historial/siguiente', {
    params: { tipoDocumento, serieDocumento, tipoOperacion }
  })
